import useCartStore from "../../utils/cartStore";
import { useState } from "react";

const GOUTS_MENDIANTS = [
  { id: "noir",  label: "Noir",  color: "#1a1a1a", image: "/images/mendiants/mendiants_noir.jpg" },
  { id: "lait",  label: "Lait",  color: "#C68642", image: "/images/mendiants/mendiants_aulait.jpg" },
  { id: "blanc", label: "Blanc", color: "#F5F0E8", image: "/images/mendiants/mendiants_blanc.jpg" },
  { id: "gold",  label: "Gold",  color: "#D4AF37", image: "/images/mendiants/mendiants_gold.jpg" },
  { id: "ruby",  label: "Ruby",  color: "#9B1B30", image: "/images/mendiants/mendiants_ruby.jpg" },
];

const GOUTS_ORIENT = [
  { id: "noir", label: "Chocolat noir, dattes, sésame & pistache", color: "#1a1a1a" },
  { id: "lait", label: "Chocolat au lait, pâte d'amande & fleurs d'oranger", color: "#C68642" },
];

const GOUTS_ROSES = [
  { id: "praline-royal",   label: "Praliné Royal",   image: "/images/gouts_roses/praline-royal.png" },
  { id: "nuit-gourmand",   label: "Nuit Gourmand",   image: "/images/gouts_roses/nuit-gourmand.png" },
  { id: "neige-croquante", label: "Neige Croquante", image: "/images/gouts_roses/neige-croquante.png" },
  { id: "rose-orient",     label: "Rose d'Orient",   image: "/images/gouts_roses/rose-orient.png" },
  { id: "coeur-lait-pistache",          label: "Cœur de Lait Creme Pistache",       image: "/images/gouts_roses/coeur-lait-pistache.png" },
  { id: "coeur-lait-praline-noisette",  label: "Cœur de Lait Praliné Noisette",    image: "/images/gouts_roses/coeur-lait-praline-noisette.png" },
];

const VIDE = (liste) => Object.fromEntries(liste.map((g) => [g.id, 0]));

const EcrinDouceurCard = () => {
  const addToCart = useCartStore((state) => state.addToCart);
  const [quantity, setQuantity] = useState(1);

  const [repMendiants, setRepMendiants] = useState(VIDE(GOUTS_MENDIANTS));
  const [repOrient, setRepOrient] = useState(VIDE(GOUTS_ORIENT));
  const [repRoses, setRepRoses] = useState(VIDE(GOUTS_ROSES));

  const totalMendiants = Object.values(repMendiants).reduce((a, b) => a + b, 0);
  const totalOrient = Object.values(repOrient).reduce((a, b) => a + b, 0);
  const totalRoses = Object.values(repRoses).reduce((a, b) => a + b, 0);

  const restantMendiants = 8 - totalMendiants;
  const restantOrient = 8 - totalOrient;
  const restantRoses = 8 - totalRoses;

  const mendiantsPret = totalMendiants === 8;
  const orientPret = totalOrient === 8;
  const rosesPret = totalRoses === 8;

  const pret = mendiantsPret && orientPret && rosesPret;

  const makeHandlers = (rep, setRep, restant) => ({
    increase: (id) => { if (restant <= 0) return; setRep((p) => ({ ...p, [id]: p[id] + 1 })); },
    decrease: (id) => { if (rep[id] <= 0) return; setRep((p) => ({ ...p, [id]: p[id] - 1 })); },
  });

  const hMendiants = makeHandlers(repMendiants, setRepMendiants, restantMendiants);
  const hOrient = makeHandlers(repOrient, setRepOrient, restantOrient);
  const hRoses = makeHandlers(repRoses, setRepRoses, restantRoses);

  const buildDescription = () => {
    const mendiants = GOUTS_MENDIANTS.filter((g) => repMendiants[g.id] > 0).map((g) => `${repMendiants[g.id]}x ${g.label}`).join(", ");
    const orient = GOUTS_ORIENT.filter((g) => repOrient[g.id] > 0).map((g) => `${repOrient[g.id]}x ${g.label}`).join(", ");
    const roses = GOUTS_ROSES.filter((g) => repRoses[g.id] > 0).map((g) => `${repRoses[g.id]}x ${g.label}`).join(", ");
    return [
      `Mendiants (8) : ${mendiants}`,
      `Carrés d'Orient (8) : ${orient}`,
      `Roses en chocolat (8) : ${roses}`,
    ].join("\n");
  };

  const handleAddToCart = () => {
    if (!pret) return;
    addToCart({
      id: `ecrin-douceur-${Date.now()}`,
      name: "L'Écrin Douceur",
      price: 49,
      image: "/images/ecrin-douceur/ecrin-douceur.jpg",
      category: "L'Écrin Douceur",
      description: buildDescription(),
    }, quantity);
    setRepMendiants(VIDE(GOUTS_MENDIANTS));
    setRepOrient(VIDE(GOUTS_ORIENT));
    setRepRoses(VIDE(GOUTS_ROSES));
    setQuantity(1);
  };

  const renderBadge = (pret, restant, label) => (
    <div className={`text-xs font-medium mb-3 px-3 py-1 rounded-full inline-block ${pret ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
      {pret ? "✓ Sélection complète !" : `${restant} ${label}${restant > 1 ? "s" : ""} restant${restant > 1 ? "s" : ""}`}
    </div>
  );

  return (
    <div className="bg-white rounded-2xl shadow p-6 max-w-2xl mx-auto">
      <img
        src="/images/ecrin-douceur/ecrin-douceur.jpg"
        alt="L'Écrin Douceur"
        className="w-full h-64 object-cover rounded-xl mb-4"
      />
      <h2 className="text-2xl font-semibold mb-1">L'Écrin Douceur</h2>
      <p className="text-gray-500 text-sm mb-3">
        Coffret de 24 pièces : 8 Mendiants, 8 Carrés d'Orient, 8 Roses en chocolat garnies
      </p>
      <p className="text-xl font-bold mb-6">49 €</p>

      {/* MENDIANTS */}
      <div className="mb-6">
        <p className="text-sm font-semibold mb-2 text-gray-700">8 Mendiants — choisissez les goûts :</p>
        {renderBadge(mendiantsPret, restantMendiants, "mendiant")}
        <div className="space-y-2">
          {GOUTS_MENDIANTS.map((g) => {
            const count = repMendiants[g.id];
            return (
              <div key={g.id} className="flex items-center gap-3">
                <img src={g.image} alt={g.label} className="w-10 h-10 rounded-lg object-cover flex-shrink-0" />
                <span className="text-sm text-gray-700 flex-1">{g.label}</span>
                <div className="flex items-center gap-2">
                  <button onClick={() => hMendiants.decrease(g.id)} disabled={count === 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${count === 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>−</button>
                  <span className="w-5 text-center text-sm font-semibold">{count}</span>
                  <button onClick={() => hMendiants.increase(g.id)} disabled={restantMendiants <= 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${restantMendiants <= 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>+</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* CARRES D'ORIENT */}
      <div className="mb-6">
        <p className="text-sm font-semibold mb-2 text-gray-700">8 Carrés d'Orient — choisissez les goûts :</p>
        {renderBadge(orientPret, restantOrient, "carré")}
        <div className="space-y-2">
          {GOUTS_ORIENT.map((g) => {
            const count = repOrient[g.id];
            const isDark = g.id === "noir";
            return (
              <div key={g.id} className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-lg flex-shrink-0 border border-gray-200 flex items-center justify-center" style={{ background: g.color }}>
                  <span className={`text-xs font-bold ${isDark ? "text-white" : "text-gray-700"}`}>{g.id === "noir" ? "N" : "L"}</span>
                </span>
                <span className="text-sm text-gray-700 flex-1">{g.label}</span>
                <div className="flex items-center gap-2">
                  <button onClick={() => hOrient.decrease(g.id)} disabled={count === 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${count === 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>−</button>
                  <span className="w-5 text-center text-sm font-semibold">{count}</span>
                  <button onClick={() => hOrient.increase(g.id)} disabled={restantOrient <= 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${restantOrient <= 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>+</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* ROSES */}
      <div className="mb-6">
        <p className="text-sm font-semibold mb-2 text-gray-700">8 Roses en chocolat — choisissez les goûts :</p>
        {renderBadge(rosesPret, restantRoses, "rose")}
        <div className="space-y-2">
          {GOUTS_ROSES.map((g) => {
            const count = repRoses[g.id];
            return (
              <div key={g.id} className="flex items-center gap-3">
                <img src={g.image} alt={g.label} className="w-10 h-10 rounded-lg object-cover flex-shrink-0" />
                <span className="text-sm text-gray-700 flex-1">{g.label}</span>
                <div className="flex items-center gap-2">
                  <button onClick={() => hRoses.decrease(g.id)} disabled={count === 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${count === 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>−</button>
                  <span className="w-5 text-center text-sm font-semibold">{count}</span>
                  <button onClick={() => hRoses.increase(g.id)} disabled={restantRoses <= 0}
                    className={`w-7 h-7 rounded border text-sm font-bold transition-colors ${restantRoses <= 0 ? "border-gray-200 text-gray-300 cursor-not-allowed" : "border-gray-400 text-gray-700 hover:border-primary hover:text-primary"}`}>+</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Quantité */}
      <div className="flex items-center gap-3 mb-4">
        <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="w-8 h-8 border rounded">−</button>
        <span>{quantity}</span>
        <button onClick={() => setQuantity(quantity + 1)} className="w-8 h-8 border rounded">+</button>
      </div>

      <button
        onClick={handleAddToCart}
        disabled={!pret}
        className={`w-full py-2 rounded-xl font-semibold transition-colors ${pret ? "btn-primary cursor-pointer" : "bg-gray-200 text-gray-400 cursor-not-allowed"}`}
      >
        {!mendiantsPret ? "Complétez vos 8 mendiants"
          : !orientPret ? "Complétez vos 8 carrés d'Orient"
          : !rosesPret ? "Complétez vos 8 roses"
          : "Ajouter au panier"}
      </button>
    </div>
  );
};

const EcrinDouceur = () => {
  return (
    <div className="section-padding">
      <h1 className="text-4xl font-bold mb-4">L'Écrin Douceur</h1>
      <p className="text-gray-500 mb-2 max-w-2xl">
        Un coffret raffiné composé de 24 pièces, réalisées à la main avec des ingrédients de qualité, dans le souci du détail, de l'élégance et du goût.
      </p>
      <p className="text-gray-500 mb-12 max-w-2xl">
        Un coffret chic, prêt à offrir, pensé comme un véritable cadeau d'exception.
      </p>
      <div className="flex justify-center">
        <EcrinDouceurCard />
      </div>
    </div>
  );
};

export default EcrinDouceur;